// Imported and modified from https://gist.github.com/AmrMekkawy/a5425a4dd4e453a4eb4d
const CURRENCIES = [
  { value: 'USD', text: 'United States Dollars' },
  { value: 'EUR', text: 'Euro' },
  { value: 'GBP', text: 'United Kingdom Pounds' },
  { value: 'DZD', text: 'Algeria Dinars' },
  { value: 'ARP', text: 'Argentina Pesos' },
  { value: 'AUD', text: 'Australia Dollars' },
  { value: 'ATS', text: 'Austria Schillings' },
  { value: 'BSD', text: 'Bahamas Dollars' },
  { value: 'BBD', text: 'Barbados Dollars' },
  { value: 'BEF', text: 'Belgium Francs' },
  { value: 'BMD', text: 'Bermuda Dollars' },
  { value: 'BRR', text: 'Brazil Real' },
  { value: 'BGL', text: 'Bulgaria Lev' },
  { value: 'CAD', text: 'Canada Dollars' },
  { value: 'CLP', text: 'Chile Pesos' },
  { value: 'CNY', text: 'China Yuan Renmimbi' },
  { value: 'CYP', text: 'Cyprus Pounds' },
  { value: 'CSK', text: 'Czech Republic Koruna' },
  { value: 'DKK', text: 'Denmark Kroner' },
  { value: 'NLG', text: 'Dutch Guilders' },
  { value: 'EGP', text: 'Egypt Pounds' },
  { value: 'FJD', text: 'Fiji Dollars' },
  { value: 'FIM', text: 'Finland Markka' },
  { value: 'FRF', text: 'France Francs' },
  { value: 'DEM', text: 'Germany Deutsche Marks' },
  { value: 'GRD', text: 'Greece Drachmas' },
  { value: 'HKD', text: 'Hong Kong Dollars' },
  { value: 'HUF', text: 'Hungary Forint' },
  { value: 'ISK', text: 'Iceland Krona' },
  { value: 'INR', text: 'India Rupees' },
  { value: 'IDR', text: 'Indonesia Rupiah' },
  { value: 'IEP', text: 'Ireland Punt' },
  { value: 'ILS', text: 'Israel New Shekels' },
  { value: 'ITL', text: 'Italy Lira' },
  { value: 'JMD', text: 'Jamaica Dollars' },
  { value: 'JPY', text: 'Japan Yen' },
  { value: 'JOD', text: 'Jordan Dinar' },
  { value: 'LBP', text: 'Lebanon Pounds' },
  { value: 'LUF', text: 'Luxembourg Francs' },
  { value: 'MYR', text: 'Malaysia Ringgit' },
  { value: 'MXP', text: 'Mexico Pesos' },
  { value: 'NZD', text: 'New Zealand Dollars' },
  { value: 'NOK', text: 'Norway Kroner' },
  { value: 'PKR', text: 'Pakistan Rupees' },
  { value: 'PHP', text: 'Philippines Pesos' },
  { value: 'PLZ', text: 'Poland Zloty' },
  { value: 'PTE', text: 'Portugal Escudo' },
  { value: 'ROL', text: 'Romania Leu' },
  { value: 'RUR', text: 'Russia Rubles' },
  { value: 'SAR', text: 'Saudi Arabia Riyal' },
  { value: 'SGD', text: 'Singapore Dollars' },
  { value: 'SKK', text: 'Slovakia Koruna' },
  { value: 'ZAR', text: 'South Africa Rand' },
  { value: 'KRW', text: 'South Korea Won' },
  { value: 'ESP', text: 'Spain Pesetas' },
  { value: 'SDD', text: 'Sudan Dinar' },
  { value: 'SEK', text: 'Sweden Krona' },
  { value: 'CHF', text: 'Switzerland Francs' },
  { value: 'TWD', text: 'Taiwan Dollars' },
  { value: 'THB', text: 'Thailand Baht' },
  { value: 'TTD', text: 'Trinidad and Tobago Dollars' },
  { value: 'TRL', text: 'Turkey Lira' },
  { value: 'VEB', text: 'Venezuela Bolivar' },
  { value: 'ZMK', text: 'Zambia Kwacha' },
  { value: 'XCD', text: 'Eastern Caribbean Dollars' },
  { value: 'XDR', text: 'Special Drawing Right (IMF)' },
  { value: 'XAG', text: 'Silver Ounces' },
  { value: 'XAU', text: 'Gold Ounces' },
  { value: 'XPD', text: 'Palladium Ounces' },
  { value: 'XPT', text: 'Platinum Ounces' },
];

export default CURRENCIES;



// WEBPACK FOOTER //
// ./src/constants/currencies.js